import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "@pages/Home/Home";
import Users from "@pages/Users/Users";
import Login from "@pages/Auth/Login";
import LayerComponent from "@shared/components/LayerComponent";
import RequireAuth from "@routes/RequireAuth";
import CheckEmail from "@pages/CheckEmail/CheckEmail";
import MainComponent from "@pages/Project/CreateProject";
import ProjectPage from "@pages/Project/ProjectPage";
import { EmailProvider } from "@services/EmailContext";
import ReportPage from "@pages/Report/ReportProcessingPage";
import ResultReportPage from "@pages/Report/ResultReportPage";
import Templates from "@pages/Template/Templates";
import CreateTemplatePage from "@pages/Template/CreateTemplate";
import ChooseTemplatePage from "@pages/Template/ChooseTemplate";
import EditTemplate from "@pages/Template/EditTemplate";
import { ProjectChatProvider } from "@services/ProjectChatContext";
import { UserProvider } from "@services/UserContext";
import { SidebarProvider } from "@services/SidebarContext";
import ProjectsOverview from "@pages/ProjectsOverview/ProjectsOverview";
import StaticHTMLPage from "@pages/StaticHTMLPage/StaticHTMLPage";
import ReportPublicPage from "@pages/Report/ReportPublicPage";
import Site from "@pages/Site/Site";
import Programs from "@pages/Program/Programs";
import CreateProgram from "@pages/Program/CreateProgram";
import ProgramDetails from "@pages/Program/ProgramDetails";
import EditProgram from "@pages/Program/EditProgram";
import ChooseMilestoneTemplate from "@pages/Program/components/milestones/ChooseMilestoneTemplate";
import Assistant from "@pages/Assistant/Assistant";
import Evaluation from "@pages/Evaluation/Evaluation";
import { AppProvider } from "@shared/context/AppContext";
import Register from "@pages/Auth/Register";
import ThankYou from "@pages/Auth/ThankYou";
import ManageMembers from "@pages/Member/ManageMember";
import Error404 from "@pages/Error/Error404";
import TakeTour from "@pages/TakeTour/TakeTour";

const AppRoutes: React.FC = () => {
  return (
    <EmailProvider>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/privacy" element={<StaticHTMLPage page={"privacy"} />} />
        <Route path="/terms" element={<StaticHTMLPage page={"terms"} />} />
        <Route path="/about" element={<StaticHTMLPage page={"about"} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route
          path="/thank-you-company"
          element={<ThankYou accountConfirmiation={true} />}
        />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route
          path="project/:projectId/report/:reportId/public"
          element={<ReportPublicPage />}
        />
        <Route
          element={
            <UserProvider>
              <AppProvider>
                <SidebarProvider>
                  <ProjectChatProvider>
                    <RequireAuth>
                      <LayerComponent />
                    </RequireAuth>
                  </ProjectChatProvider>
                </SidebarProvider>
              </AppProvider>
            </UserProvider>
          }
        >
          <Route
            path="/report/:reportId/project/:projectId"
            element={<ResultReportPage />}
          />
          <Route path="/user/:id" element={<Users />} />
          <Route path="/projects-overview" element={<ProjectsOverview />} />
          {/* Project Routes */}
          <Route path="/projects" element={<Home />} />
          <Route path="/create-project" element={<MainComponent />} />
          <Route path="/project/:projectId" element={<ProjectPage />} />
          <Route
            path="/project/:projectId/token/:sharedToken"
            element={<ProjectPage />}
          />
          {/* Report Routes */}
          <Route
            path="/project/:projectId/report-creation/:taskId"
            element={<ReportPage />}
          />

          {/* Template Routes */}
          <Route path="/templates" element={<Templates />} />
          <Route path="/create-template" element={<CreateTemplatePage />} />
          <Route path="/choose-template" element={<ChooseTemplatePage />} />
          <Route
            path="/choose-milestone-template"
            element={<ChooseMilestoneTemplate />}
          />
          <Route path="/template/:templateId/edit" element={<EditTemplate />} />

          {/* Program Routes */}
          <Route path="/programs" element={<Programs />} />
          <Route path="/create-program" element={<CreateProgram />} />
          <Route path="/program/:programId" element={<ProgramDetails />} />
          <Route path="/program/:programId/edit" element={<EditProgram />} />

          {/* Assitant Routes */}
          <Route path="/home" element={<Assistant />} />
          <Route path="/assistant" element={<Assistant />} />
          <Route
            path="/assistant/conversation/:conversationId"
            element={<Assistant />}
          />

          {/* Evaluation Routes */}
          <Route path="/evaluation" element={<Evaluation />} />

          <Route path="/manage-members" element={<ManageMembers />} />

          <Route path="/take-tour" element={<TakeTour />} />
        </Route>
        <Route path="*" element={<Error404 />} />
      </Routes>
    </EmailProvider>
  );
};

export default AppRoutes;
